import { Button, Combobox, Divider, Field, Input, Option, Radio, RadioGroup, Switch, Text, makeStyles, shorthands, typographyStyles } from "@fluentui/react-components";
import { SearchRequest } from "../../library/CosmeWidgetAPIClient";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { useContext, useEffect, useState } from "react";
import { CWClientContext } from "../../App";

const useStyles = makeStyles({
    box: {
        marginTop: "10px",
        marginLeft: "10px",
        marginRight: "10px",

    },
    datepicker: {
        zIndex: 99,
    },
    radioText: {
        ...typographyStyles.subtitle2Stronger
    },
    captionText: {
        ...typographyStyles.caption1
    },
    fieldDivider: {
        marginTop: "25px",
    },
    pickerWrapper: {
        minWidth: "15%",
        width: "15%",
    },
    limitBox: {
        minWidth: "90%",
        ...shorthands.margin("auto"),
    },
});


type Media = {
    host: string;
    name: string;
    search: boolean;
}

const mediaList: Media[] = [
    {
        host: "www.biteki.com",
        name: "美的.com",
        search: true,
    },
    {
        host: "i-voce.jp",
        name: "i-Voce",
        search: true,
    },
    {
        host: "maquia.hpplus.jp",
        name: "MAQUIA ONLINE",
        search: true,
    },
];
type ExtractFilterBarProp = {
    searchCallback: (request: SearchRequest) => void;
    defaultSearch: {
        status: string | undefined;
        startDate: Date | undefined;
        media: Media[] | undefined;
        biteki: boolean | undefined;
        ivoce: boolean | undefined;
        maquia: boolean | undefined;

    }
}
function ExtractFilterBar(prop: ExtractFilterBarProp) {
    const styles = useStyles();


    const [status, setStatus] = useState("DETECTED");
    const [startDate, setStartDate] = useState<Date>(new Date());
    const [media, setMedia] = useState<Media[]>(mediaList);
    const [biteki, setBiteki] = useState(true);
    const [ivoce, setIvoce] = useState(true);
    const [maquia, setMaquia] = useState(true);

    const [limit, setLimit] = useState(100);
    const [num, setNum] = useState(0);
    const cwClient = useContext(CWClientContext);

    const onFormDate = (date?: Date): string => {
        console.log("onFormDate = ", date);
        return !date
            ? ""
            :
            (date.getFullYear()) +
            "/" +
            (date.getMonth() + 1) +
            "/" +
            date.getDate() +
            "/";
    };

    const parseDate = (date: string): Date => {
        let d = date.split("/");
        return new Date(parseInt(d[0]), parseInt(d[1]) - 1, parseInt(d[2]));
    }

    const onSearch = () => {

        console.log("startDate = ", startDate, startDate?.toUTCString());
        let media: string[] = [];
        if (biteki) {
            media.push("www.biteki.com");
        }
        if (ivoce) {
            media.push("i-voce.jp");
        }
        if (maquia) {
            media.push("maquia.hpplus.jp");
        }
        let request: SearchRequest = {
            status: status,
            startDate: startDate,
            endDate: startDate,
            limit: limit,
            media: media,
            offset: 0,
        };

        cwClient?.searchCount(request).then((res) => {
            console.log("res = ", res);
            setNum(res.count);
        });

        prop.searchCallback(request);
    }

    useEffect(() => {
        restore();
        console.log("media = ", media);
        onSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const restore = () => {
        // Start date
        let sd = new Date();
        let ssd = sessionStorage.getItem("startDate");
        console.debug("session stored Date = ", ssd);
        if (ssd !== null) {
            sd = new Date(ssd);
        }
        console.debug("restored startDate = ", sd)
        setStartDate(sd);
        // Media
        let sm = sessionStorage.getItem("media");
        console.debug("session stored media = ", sm);
    };

    useEffect(() => {
        sessionStorage.setItem("startDate", startDate.toUTCString());
    }, [startDate]);

    useEffect(() => {
        console.log("useEffect media = ", media);
    }, [media]);

    const mediaSwitch = () => {
        return (
            <>
                {media.map((m) => {
                    let name = m.name;
                    return (
                        <Switch
                            checked={(() => {
                                if (m.host === "www.biteki.com") {
                                    return biteki;
                                } else if (m.host === "i-voce.jp") {
                                    return ivoce;
                                } else if (m.host === "maquia.hpplus.jp") {
                                    return maquia;
                                } else {
                                    return false;
                                }
                            })()
                            }
                            label={name}
                            onChange={
                                (e, data) => {
                                    console.log(media);
                                    m.search = data.checked;
                                    media.map((mm, index, medias) => {
                                        if (mm.host === m.host) {
                                            console.log("mm.host ==", mm)
                                            medias[index] = m;
                                            setMedia(medias);
                                            (() => {
                                                if (m.host === "www.biteki.com") {
                                                    setBiteki(data.checked);
                                                } else if (m.host === "i-voce.jp") {
                                                    setIvoce(data.checked);
                                                } else if (m.host === "maquia.hpplus.jp") {
                                                    setMaquia(data.checked);
                                                }
                                            })();
                                        }
                                    });
                                    console.log(media);
                                }
                            }
                        />
                    );
                })}
            </>
        );
    };

    return (
        <>
            <div className={styles.box}>
                <Divider className={styles.fieldDivider}
                >ステータス</Divider>
                <RadioGroup
                    defaultChecked={true}
                    value={status}
                    onChange={(e, value) => {
                        setStatus(value.value);
                    }}
                >
                    <Radio
                        className={styles.radioText}
                        value="DONE"
                        label={
                            <>
                                チェック済み
                                <br />
                                <Text className={styles.captionText}>
                                    人によるチェックが完了しているもの。
                                </Text>
                            </>
                        }
                    />
                    <Radio
                        className={styles.radioText}
                        value="PENDING"
                        label={
                            <>
                                保留中
                                <br />
                                <Text className={styles.captionText}>
                                    人によるチェックをしたが、完了していないもの。
                                </Text>
                            </>
                        }
                    />

                    <Radio
                        className={styles.radioText}
                        value="DETECTED"
                        label={
                            <>
                                AIで抽出済み(新着)
                                <br />
                                <Text className={styles.captionText}>
                                    AIによる抽出が完了しているもの。
                                </Text>
                            </>
                        }
                    />

                    <Radio
                        className={styles.radioText}
                        value="NONE"
                        label={
                            <>
                                抽出前
                                <br />
                                <Text className={styles.captionText}>
                                    記事を保存しているが、AIによる抽出が終わっていないもの。
                                </Text>
                            </>
                        }
                    />
                    <Radio
                        className={styles.radioText}
                        value="IGNORE"
                        label={
                            <>
                                無視したもの
                                <br />
                                <Text className={styles.captionText}>

                                </Text>
                            </>
                        }
                    />
                </RadioGroup>
                <Divider className={styles.fieldDivider} >
                    日付
                </Divider>
                <Field label="日付">
                    <DatePicker
                        className={styles.datepicker}
                        placeholder="Select a date..."
                        formatDate={onFormDate}
                        value={startDate}
                        maxDate={new Date()}
                        onSelectDate={(date) => {
                            if (date !== null && date !== undefined) {
                                setStartDate(date);
                            } else {

                            }
                        }}

                    />
                </Field>

                <Divider className={styles.fieldDivider}>
                    サイト
                </Divider>
                <Field>
                    {mediaSwitch()}
                </Field>
                <Divider>
                    表示件数
                </Divider>
                <Combobox
                    className={styles.limitBox}
                    placeholder="表示件数"
                    defaultSelectedOptions={[limit.toString()]}
                    onOptionSelect={(e, data) => {
                        console.log("data = ", data);
                        if (data.optionValue !== undefined) {
                            setLimit(parseInt(data.optionValue));
                        }
                    }}
                >
                    <Option key="10" >10件</Option>
                    <Option key="25" >25件</Option>
                    <Option key="50" >50件</Option>
                    <Option key="100" >100件</Option>
                    <Option key="200" >200件</Option>

                </Combobox>

                <Divider
                    className={styles.fieldDivider}
                >
                    URL
                </Divider>

                <Field
                    label="URLで検索した場合、それ以外の項目は無視されます。"
                >
                    <Input></Input>

                </Field>


                <Button
                    onClick={onSearch}
                >
                    検索
                </Button>

                <br />
                件数：{num}
            </div>
        </>
    );
}

export default ExtractFilterBar;